"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportCompositePhoto = void 0;
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const i18n_1 = require("../../../i18n");
const store_1 = require("../../../store");
const DataGrid_1 = require("../components/DataGrid");
const ImageGrid_1 = require("../components/ImageGrid");
const ImageWithTitle_1 = require("../components/ImageWithTitle");
const TitleBar_1 = require("../components/TitleBar");
const DataExtractor_1 = require("../DataExtractor");
const ReportHelpers_1 = require("../ReportHelpers");
const ReportBase_1 = require("./ReportBase");
class ReportCompositePhoto extends ReportBase_1.ReportBase {
    constructor(poles) {
        super(poles);
    }
    buildPDF() {
        this.poles.forEach((pole, i) => {
            const job = store_1.AppStore.Tag.get(pole.jobId);
            const fullImages = [];
            const tagArr = [];
            const tagImageGrids = {};
            // Title
            this.nodes.push(new TitleBar_1.TitleBar(pole.title || (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE), job.name, i + 1, this.poles.length));
            pole.forEachField((field) => {
                // Data grid of items outside of subforms
                if (field.parent.parent == null) {
                    if (field.hasValue() &&
                        field.schema.type !== core_api_1.IkeFieldType.FORM &&
                        field.schema.type !== core_api_1.IkeFieldType.IMAGE &&
                        field.schema.type !== core_api_1.IkeFieldType.TRUE_SIZE) {
                        const extractedValue = DataExtractor_1.DataExtractor.createPrintableValue(field);
                        tagArr.push([extractedValue.title, extractedValue.value]);
                    }
                    // Image grid
                    if (field instanceof core_shared_1.CollectionModelFieldImage) {
                        const captures = field.getCaptures();
                        captures.forEach(capture => {
                            if (!(0, ReportHelpers_1.isCaptureHidden)(pole, capture.objectId)) {
                                const imageReferenceString = (0, ReportHelpers_1.captureReferenceString)(pole, capture);
                                this.images[imageReferenceString] = capture.medium.url;
                                if (!tagImageGrids[field.schema.displayName]) {
                                    tagImageGrids[field.schema.displayName] = [];
                                }
                                tagImageGrids[field.schema.displayName].push({ reference: imageReferenceString, timeStamp: new Date(capture.createdAt) });
                            }
                        });
                    }
                    // Truesize images
                    if (field instanceof core_shared_1.CollectionModelFieldTrueSize) {
                        const captures = field.getCaptures();
                        captures.forEach(capture => {
                            if (!(0, ReportHelpers_1.isCaptureHidden)(pole, capture.objectId)) {
                                if ((0, ReportHelpers_1.hasUserMeasurement)(pole, capture.objectId)) {
                                    const imageReferenceString = (0, ReportHelpers_1.captureReferenceString)(pole, capture);
                                    this.images[imageReferenceString] = (0, ReportHelpers_1.compositeURL)(pole, capture);
                                    fullImages.push([field.schema.displayName, imageReferenceString]);
                                }
                            }
                        });
                    }
                }
            });
            // Top level data grid
            this.nodes.push(new DataGrid_1.DataGrid(tagArr));
            // Tag image in a grid
            this.nodes.push(new ImageGrid_1.ImageGrid(tagImageGrids));
            // Full size composite images
            fullImages.forEach(image => {
                this.nodes.push(new ImageWithTitle_1.ImageWithTitle(image[0], { reference: image[1] }));
            });
        });
    }
}
exports.ReportCompositePhoto = ReportCompositePhoto;
//# sourceMappingURL=ReportCompositePhoto.js.map